// extracted by css-extract-rspack-plugin
export default {"listItem":"EInvoiceTypePicker_listItem__FIOs9","divider":"EInvoiceTypePicker_divider__SyI99"};